// extracted by mini-css-extract-plugin
module.exports = {"input":"inputs_input__zUk_k"};